const ShopSkinDtComponent = () => import('@/views/shop/ShopSkinDt/ShopSkinDtView')

export default [
    {
        path:'/ShopSkinDtIndex',
        name:'ShopSkinDtRouter',
        component:ShopSkinDtComponent
    }
]